import { BrandCustomData } from '../../../types/brand_settings';

export type BrandCustomDataState = {
  data: BrandCustomData[];
  loading: boolean;
};

const initialState: BrandCustomDataState = {
  data: [],
  loading: false,
};

type Action = {
  type: string;
  payload?: any;
  meta?: any;
};

const reducer = (state = initialState, action: Action): BrandCustomDataState => {
  switch (action.type) {
    case 'FETCH_BRAND_CUSTOM_DATA_PENDING':
      return {
        ...state,
        loading: true,
      };
    case 'FETCH_BRAND_CUSTOM_DATA_FULFILLED':
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };
    case 'FETCH_BRAND_CUSTOM_DATA_REJECTED':
      return {
        ...state,
        loading: false,
      };
    case 'UPDATE_BRAND_CUSTOM_DATA_PENDING':
      return {
        ...state,
        loading: true,
      };
    case 'UPDATE_BRAND_CUSTOM_DATA_FULFILLED':
      return {
        ...state,
        loading: false,
      };
    case 'UPDATE_BRAND_CUSTOM_DATA_REJECTED':
      return {
        ...state,
        loading: false,
      };
    case 'DELETE_BRAND_CUSTOM_DATA_PENDING':
      return {
        ...state,
        data: state.data.filter(item => item.id !== action.meta.customDataFieldId),
        loading: false,
      };
    case 'DELETE_BRAND_CUSTOM_DATA_FULFILLED':
      return {
        ...state,
        loading: false,
      };
    case 'DELETE_BRAND_CUSTOM_DATA_REJECTED':
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
